const STEPS = {
  INSTRUCTIONS: 'instructions',
  UPLOAD_AND_FORM: 'uploadAndForm',
  VERIFY_VOICE: 'verifyVoice',
};

const AUTO_SAVE_STATUS = {
  IDLE: 'idle',
  SAVING: 'saving',
  SUCCESS: 'success',
};

const AUDIO_ACCEPT = '.wav';
const MAX_SIZE = 10 * 1024 * 1024; // 10MB
const MIN_DURATION = 10; // seconds
const MAX_DURATION = 30; // seconds

const AUDIO_STATUS = {
  UPLOADING: 'uploading',
  ERROR: 'error',
  SUCCESS: 'success',
  CHECKING_QUALITY: 'checkingQuality',
};

const MAX_AUDIO_LIMIT = 100; // 100 audio files
const MAX_TOTAL_DURATION_LIMIT = 10 * 60 * 60; // 10 hours
const MAX_AUDIO_DURATION_LIMIT = 10 * 60; // 10 minutes
const MIN_AUDIO_DURATION_LIMIT = 30; // 30 seconds
const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB

const ERROR_CODE_VOICE_CLONING_UPLOAD = {
  MAX_TOTAL_DURATION_REACHED: 'FINETUNE_LONG_AUDIO_MAX_TOTAL_DURATION_REACHED',
};

export {
  STEPS,
  AUTO_SAVE_STATUS,
  AUDIO_ACCEPT,
  MAX_SIZE,
  MIN_DURATION,
  MAX_DURATION,
  AUDIO_STATUS,
  MAX_AUDIO_LIMIT,
  MAX_TOTAL_DURATION_LIMIT,
  MAX_AUDIO_DURATION_LIMIT,
  MIN_AUDIO_DURATION_LIMIT,
  MAX_FILE_SIZE,
  ERROR_CODE_VOICE_CLONING_UPLOAD,
};
